import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { GovernmentProjectSearchProvider } from './context/government-project-search-context';
import { GovernmentProjectSearchComponent } from './government-project-search-component';

export function GovernmentProjectSearchFactory() {
    return (
        <BaseLayoutFactory>
            <GovernmentProjectSearchProvider>
                <GovernmentProjectSearchComponent />
            </GovernmentProjectSearchProvider>
        </BaseLayoutFactory>
    );
}
